import { Subtitle } from '@/components/commons/typography/Subtitle'
import { Text } from '@/components/commons/typography/Text'
import { cssClass } from '@/shared/utils'
import {
  useIsOwnProfile,
  useProfile,
} from 'containers/profile/hooks/useProfile'
import { BrowserContext } from 'context'
import { useContext } from 'react'

interface AboutSectionProps {
  trimmed?: boolean
}

export const AboutSection = ({ trimmed }: AboutSectionProps) => {
  const { profile } = useProfile()
  const isOwnProfile = useIsOwnProfile()
  const { isMobile } = useContext(BrowserContext)

  const isAboutEmpty = !profile?.about || profile?.about === ''
  const text = !isAboutEmpty
    ? profile?.about
    : isOwnProfile
    ? 'Tell Your Story – Use this space to highlight your journey,...'
    : `Help ${
        profile?.firstName || 'this creator'
      } enrich their profile! Connect to share resources, insights, opportunities, and more!`

  return (
    <div>
      <Subtitle
        sizeClass="text-14 text-15--tablet"
        weightClass="font-bold font-medium--tablet"
      >
        About Me
      </Subtitle>
      <Text
        sizeClass="text-14 text-16--tablet"
        colorClass="text-tertirary"
        className={cssClass([trimmed && isMobile && 'break-text', 'mt-10'])}
        style={{ whiteSpace: 'pre-line' }}
      >
        {text}
      </Text>
    </div>
  )
}
